import { EsgCompliantUploadedDocumentApi } from "@/api";
import i18n from "@/i18n";
import { showErrorSnackbar, showSuccessSnackbar } from "@/utilities/snackbar";
import { DownloadFile } from "@/utilities/fileManager.js";

export async function get(enterpriseId, params) {
  const { data } = await EsgCompliantUploadedDocumentApi.get(
    enterpriseId,
    params
  );
  return data;
}

export async function save(formData) {
  const response = await EsgCompliantUploadedDocumentApi.save(formData);
  const fileName = formData.get("file").name;
  showSuccessSnackbar(
    200,
    `${fileName} ${i18n.t("append-to-filename-saved-correctly")}`
  );
  return response.data.document;
}

export async function remove(document) {
  try {
    await EsgCompliantUploadedDocumentApi.remove(document.id);
  } catch (ex) {
    showErrorSnackbar(undefined, i18n.t("something-went-wrong") + ex);
    return;
  }
  showSuccessSnackbar(
    200,
    `${document.fileName} ${i18n.t("append-to-filename-deleted-correctly")}`
  );
}

export async function download(id, fallbackFileName) {
  let response;
  try {
    response = await EsgCompliantUploadedDocumentApi.download(id);
    DownloadFile.downloadBlobWithHeaders(
      response.data,
      response.headers,
      fallbackFileName
    );
  } catch (ex) {
    showErrorSnackbar(undefined, i18n.t("something-went-wrong") + ex);
  }
}
